<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Relatórios de Vendas</h1>
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50 md:mb-32 ">
   <div class="p-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 bg-white shadow rounded">
  @for (report of reports; track $index) {
    <p-card>
      <ng-template #title>
        <div class="flex justify-center">
          {{report.label}}
        </div>
      </ng-template>
      <ng-template #subtitle>
        <div class="flex justify-center">
          {{report.description}}
        </div>
      </ng-template>
      <ng-template #footer>
        <div class="flex gap-4 mt-1">
          <p-button (onClick)="goTo(report.link)" label="Visualizar" class="w-full" styleClass="w-full" />
        </div>
      </ng-template>
    </p-card>
  }
</div>

  </div>
</div>